import type { ComponentType } from "react";
import { AgentDraftCard } from "./cards/AgentDraftCard";
import { BrandDraftCard } from "./cards/BrandDraftCard";
import { DataSourceDraftCard } from "./cards/DataSourceDraftCard";
import { MicroAppDraftCard } from "./cards/MicroAppDraftCard";
import { SkillDraftCard } from "./cards/SkillDraftCard";
import { WorkflowDraftCard } from "./cards/WorkflowDraftCard";
import type { DraftCardState, DraftView } from "./draftModel";

export interface EntityDraftCardProps {
  draft: DraftView;
  state: DraftCardState;
  /** The entity the draft created or saved. */
  entityUuid?: string;
  updatedAt?: string;
  /** The draft's questions can still be answered. */
  answerable: boolean;
}

/** entity_type → its card; a type without one renders the generic card. */
export const DRAFT_CARDS: Partial<Record<string, ComponentType<EntityDraftCardProps>>> = {
  agent: AgentDraftCard,
  brand: BrandDraftCard,
  data_source: DataSourceDraftCard,
  micro_app: MicroAppDraftCard,
  workflow: WorkflowDraftCard,
  skill: SkillDraftCard,
};
